"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchOutsideProgram = void 0;
var OutsideStore_1 = require("../store/OutsideStore");
var serviceUtils_1 = require("../../youwell-common/service/serviceUtils");
var apiUrls_1 = __importDefault(require("../../youwell-common/apiUrls"));
// eslint-disable-next-line import/prefer-default-export
var fetchOutsideProgram = function (dispatch, programId, options) {
    (0, serviceUtils_1.fetchFromYouwellApi)(dispatch, {
        apiPath: "".concat(apiUrls_1.default.app.public, "/").concat(programId),
        dataAction: OutsideStore_1.setProgram,
    }, options);
};
exports.fetchOutsideProgram = fetchOutsideProgram;
